// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.fade-enter-active[data-v-e50a1114], .fade-leave-active[data-v-e50a1114] {\n    transition: opacity .3s;\n}\n.fade-enter[data-v-e50a1114], .fade-leave-to[data-v-e50a1114] {\n    opacity: 0;\n}\n", ""]);
// Exports
module.exports = exports;
